import { t, useLocale } from "@/i18n/locale";
interface ErrorBannerProps {
  message: string;
  onDismiss: () => void;
}

export default function ErrorBanner({ message, onDismiss }: ErrorBannerProps) {
  useLocale();
  return (
    <div className="error-banner" role="alert">
      <span>{t(message)}</span>
      <button onClick={onDismiss} className="dismiss-btn" aria-label={t("Dismiss")}>
        ✕
      </button>
    </div>
  );
}
